<template>
  <div class="hero grid-container fluid nopadding">
    <div class="grid-x hide-for-small-only">
      <div class="cell small-12 medium-7 large-7 relative">
        <img src="../assets/keyv_left_3_1000.jpg">
      </div>
      <div class="cell small-12 medium-5 large-5 relative">
        <div class="grid-x align-center" style="height:100%">
          <div class="cell auto shrink">
            <div class="grid-y align-center grid-padding-y" style="height:100%">
              <div class="cell large-2 medium-0">
              </div>
              <div class="cell large-5 medium-6">
                <div class="subtitle">
                  Die neue ERGO BU präsentiert:
                </div>
                <div class="title mt-10">
                  So gewinnen<br>
                  Sie reihenweise<br>
                  junge Kunden.
                </div>
              </div>
              <div class="cell large-5 medium-6">
                <div class="hero-circle text-center">
                  <div class="text">
                    <div class="text-title">Ihre App:</div>
                    <div>
                      designt &<br>
                      personalisiert<br>
                      für Sie
                    </div>
                    <!--
                  mit Ihrer<br>
                  <span class="underline">eigenen</span><br>
                  Akquise-<br>
                  App
                  -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-x mob-hero show-for-small-only">
      <div class="cell large-12 medium-6 pl-20 pt-20 pb-20">
        <div class="subtitle">
          Die neue ERGO BU präsentiert:
        </div>
        <div class="title mt-10">
          So gewinnen<br>
          Sie reihenweise<br>
          junge Kunden.
        </div>
      </div>
      <div class="cell small-12 relative">
        <img src="../assets/keyv_mob_3.jpg">
        <div class="hero-circle text-center">
          <div class="text">
            <div class="text-title">Ihre App:</div>
            <div>
              designt &<br>
              personalisiert<br>
              für Sie
            </div>
            <!--
          mit Ihrer<br>
          <span class="underline">eigenen</span><br>
          Akquise-<br>
          App-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Hero',
  components: {
    
  },
  data() {
    return {
      state: this.$store.state,
      ui: {

      }
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="stylus" scoped>
.hero {
  background-color #F6DCBB
  //background-color #F4D7B5
  //height 51.4em
  img {
  }
  .subtitle {
    font-size:1.125em
    font-weight:bold
  }
  .title {
    font-size: 3.43em
    color: #8e0038
    font-family: 'FedraSerifAPro'
    font-weight: bold
    line-height:1.2
  }
  .hero-circle {
    font-size:1.375em
    color:white
    border-radius:50%
    background-color: #8e0038
    width:184px
    height:184px
    overflow:hidden
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform: rotateZ(-15deg)
    .text {
      .text-title {
        font-family: 'FedraSerifAPro'
        font-weight:bold
        line-height:1.9
        font-size:1.1em
      }
      align-items:center
      font-weight:bold
      line-height:1.3
      font-size:0.9em
      .underline {
        text-decoration: underline
        font-weight:bold
        line-height:1.6
        color:white
      }
    }
  }
  .mob-hero {
    .subtitle {
      font-size: 14px
    }
    .title {
      font-size: 26px
    }
    .hero-circle {
      position:absolute
      right:35px
      bottom:18%
      width:108px
      height:108px
      font-size:14px
      .text {
        line-height:1.2!important
      }
      .underline {
        line-height:1.2!important
      }
    }
  }
}

</style>